// First open of the app (P5.1b, D68): the page's own data is requested together with the
// profile instead of after it, saving one round trip. Only plain GETs the page makes anyway;
// the broker still checks every one of them.

const PR = /^\/requests\/([A-Z]{3}-PR-\d{4,}-\d{4})$/;

/** The API reads the page at this hash route makes when it opens. */
export function firstLoadPaths(hash: string): `/api/${string}`[] {
  const raw = hash.replace(/^#/, '');
  const path = raw.startsWith('/') ? raw : '/';
  if (path === '/') return ['/api/prs', '/api/prs/for-decision'];
  if (path === '/requests') return ['/api/prs'];
  const pr = PR.exec(path)?.[1];
  if (pr) return [`/api/prs/${encodeURIComponent(pr)}/detail`];
  if (path === '/suppliers') return ['/api/suppliers'];
  if (path === '/contracts') return ['/api/contracts'];
  return [];
}
